import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import {

  FaArchive,

  FaChartBar,

  FaEnvelope,

  FaFolderOpen,

  FaInbox,

  FaPlus,

  FaRegFileAlt,

  FaUsers,

  FaWrench,

} from 'react-icons/fa';

import { api } from '../api';



const cards = [

  { key: 'totalServices', label: 'Total Services', icon: FaWrench, color: 'from-yellow-500/20 to-yellow-400/5' },

  { key: 'totalProjects', label: 'Total Projects', icon: FaFolderOpen, color: 'from-purple-500/20 to-purple-400/5' },

  { key: 'totalBlogs', label: 'Total Blogs', icon: FaRegFileAlt, color: 'from-blue-500/20 to-blue-400/5' },

  { key: 'totalPartners', label: 'Total Partners', icon: FaUsers, color: 'from-green-500/20 to-green-400/5' },

  { key: 'totalMessages', label: 'Total Messages', icon: FaEnvelope, color: 'from-pink-500/20 to-pink-400/5' },

];



const panelClass =

  'rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-[#0a1322] dark:shadow-none';

const innerCardClass =

  'rounded-xl border border-slate-200 bg-slate-50 p-3 dark:border-white/10 dark:bg-[#0d1a2d]';



const AdminDashboard = () => {

  const [stats, setStats] = useState(null);

  const [messages, setMessages] = useState([]);

  const [projects, setProjects] = useState([]);

  const [blogs, setBlogs] = useState([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');



  useEffect(() => {

    const loadStats = async () => {
      try {
        setLoading(true);
        setError('');

        const [dashboardResult, messagesResult, projectsResult, blogsResult] = await Promise.allSettled([
          api.dashboard(),
          api.list('/api/messages'),
          api.list('/api/projects'),
          api.list('/api/blogs'),
        ]);

        if (dashboardResult.status === 'fulfilled') {
          setStats(dashboardResult.value.data);
        } else {
          setStats({
            totalServices: 0,
            totalProjects: 0,
            totalBlogs: 0,
            totalPartners: 0,
            totalMessages: 0,
          });
          setError(dashboardResult.reason?.message || 'Failed to load dashboard stats.');
        }

        if (messagesResult.status === 'fulfilled') {
          setMessages((messagesResult.value.data || []).slice().reverse());
        }

        if (projectsResult.status === 'fulfilled') {
          setProjects((projectsResult.value.data || []).slice().reverse());
        }

        if (blogsResult.status === 'fulfilled') {
          setBlogs((blogsResult.value.data || []).slice().reverse());
        }
      } catch (err) {
        setError(err.message || 'Failed to load dashboard data.');
      } finally {
        setLoading(false);
      }
    };

    loadStats();

  }, []);



  if (loading) {
    return <p className="text-slate-600 dark:text-gray-300">Loading dashboard...</p>;
  }

  const totalMessages = stats?.totalMessages ?? 0;

  const readMessages = messages.filter((item) => item.isRead).length;

  const unreadMessages = Math.max(totalMessages - readMessages, 0);

  const readPercent = totalMessages ? Math.round((readMessages / totalMessages) * 100) : 0;

  const unreadPercent = totalMessages ? Math.round((unreadMessages / totalMessages) * 100) : 0;



  return (
    <div>
      {error ? (
        <div className="mb-4 rounded-xl border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-600 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-300">
          {error}
        </div>
      ) : null}

      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">

        <div>

          <h1 className="text-3xl font-extrabold text-slate-900 dark:text-white">Welcome back, Admin!</h1>

          <p className="text-sm text-slate-500 dark:text-gray-400">Here is what is happening with your website today.</p>

        </div>

        <Link

          to="/admin/modules/services"

          className="inline-flex items-center gap-2 rounded-xl bg-primary px-4 py-2 text-sm font-bold text-black"

        >

          <FaPlus size={13} />

          Quick Action

        </Link>

      </div>



      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">

        {cards.map((card) => (

          <div

            key={card.key}

            className={`rounded-2xl border border-slate-200 bg-gradient-to-br ${card.color} p-4 shadow-sm dark:border-white/10 dark:shadow-[0_12px_32px_rgba(0,0,0,0.3)]`}

          >

            <div className="mb-3 flex items-center justify-between">

              <div className="rounded-xl bg-slate-100 p-2 text-primary dark:bg-white/10">

                <card.icon size={18} />

              </div>

              <p className="text-[11px] text-slate-500 dark:text-gray-300">vs last month</p>

            </div>

            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-gray-400">{card.label}</p>

            <p className="mt-1 text-3xl font-extrabold text-slate-900 dark:text-white">{stats?.[card.key] ?? 0}</p>

            <div className="mt-3 h-1.5 w-full rounded-full bg-slate-200 dark:bg-white/10">

              <div className="h-1.5 rounded-full bg-primary" style={{ width: `${Math.min(100, (stats?.[card.key] ?? 0) * 4)}%` }} />

            </div>

          </div>

        ))}

      </div>



      <div className="mt-5 grid grid-cols-1 gap-4 xl:grid-cols-[1.2fr_0.8fr_1fr]">

        <section className={panelClass}>

          <div className="mb-4 flex items-center justify-between">

            <h2 className="text-sm font-bold text-slate-900 dark:text-white">Website Analytics (This Year)</h2>

            <span className="text-xs text-slate-500 dark:text-gray-400">This Year</span>

          </div>

          <div className="flex h-48 items-end gap-2">

            {[20, 35, 42, 38, 50, 47, 61, 56, 72, 68, 74, 90].map((value, idx) => (

              <div key={idx} className="flex flex-1 flex-col items-center gap-2">

                <div

                  className="w-full rounded-t-md bg-gradient-to-t from-primary to-yellow-300"

                  style={{ height: `${value}%` }}

                />

                <span className="text-[10px] text-slate-400 dark:text-gray-500">

                  {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][idx]}

                </span>

              </div>

            ))}

          </div>

        </section>



        <section className={panelClass}>

          <h2 className="mb-4 text-sm font-bold text-slate-900 dark:text-white">Messages Overview</h2>

          <div className="mx-auto mb-4 flex h-36 w-36 items-center justify-center rounded-full border-8 border-slate-200 dark:border-[#1f2b3f]">

            <div

              className="flex h-full w-full items-center justify-center rounded-full"

              style={{

                background: `conic-gradient(#22c55e ${readPercent}%, #facc15 ${readPercent}% ${readPercent + unreadPercent}%, #3b82f6 ${readPercent + unreadPercent}% 100%)`,

              }}

            >

              <div className="flex h-24 w-24 flex-col items-center justify-center rounded-full bg-white dark:bg-[#0a1322]">

                <span className="text-2xl font-extrabold text-slate-900 dark:text-white">{totalMessages}</span>

                <span className="text-[11px] text-slate-500 dark:text-gray-400">Total</span>

              </div>

            </div>

          </div>

          <div className="space-y-2 text-xs">

            <p className="flex items-center justify-between text-slate-600 dark:text-gray-300">

              <span className="inline-flex items-center gap-2"><FaInbox size={12} className="text-yellow-400" />Unread</span>

              <strong>{unreadMessages}</strong>

            </p>

            <p className="flex items-center justify-between text-slate-600 dark:text-gray-300">

              <span className="inline-flex items-center gap-2"><FaEnvelope size={12} className="text-green-400" />Read</span>

              <strong>{readMessages}</strong>

            </p>

            <p className="flex items-center justify-between text-slate-600 dark:text-gray-300">

              <span className="inline-flex items-center gap-2"><FaArchive size={12} className="text-blue-400" />Archived</span>

              <strong>0</strong>

            </p>

          </div>

        </section>



        <section className={panelClass}>

          <div className="mb-3 flex items-center justify-between">

            <h2 className="text-sm font-bold text-slate-900 dark:text-white">Recent Messages</h2>

            <Link to="/admin/modules/messages" className="text-xs text-primary">View All</Link>

          </div>

          <div className="space-y-3">

            {messages.slice(0, 5).map((item) => (

              <div key={item.id} className={`flex items-center justify-between ${innerCardClass} px-3 py-2`}>

                <div>

                  <p className="text-sm font-bold text-slate-900 dark:text-white">{item.firstName} {item.lastName}</p>

                  <p className="text-xs text-slate-500 dark:text-gray-400">{item.subject}</p>

                </div>

                <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${item.isRead ? 'bg-blue-500/20 text-blue-600 dark:text-blue-300' : 'bg-primary/25 text-primary'}`}>

                  {item.isRead ? 'Read' : 'New'}

                </span>

              </div>

            ))}

            {messages.length === 0 ? <p className="text-sm text-slate-500 dark:text-gray-500">No messages yet.</p> : null}

          </div>

        </section>

      </div>



      <div className="mt-5 grid grid-cols-1 gap-4 xl:grid-cols-[1.2fr_1fr_1fr]">

        <section className={panelClass}>

          <div className="mb-3 flex items-center justify-between">

            <h2 className="text-sm font-bold text-slate-900 dark:text-white">Recent Projects</h2>

            <Link to="/admin/modules/projects" className="text-xs text-primary">View All</Link>

          </div>

          <div className="space-y-3">

            {projects.slice(0, 3).map((item) => (

              <div key={item.id} className={innerCardClass}>

                <p className="font-bold text-slate-900 dark:text-white">{item.title}</p>

                <p className="text-xs text-slate-500 dark:text-gray-400">{item.category || 'Project'}</p>

              </div>

            ))}

            {projects.length === 0 ? <p className="text-sm text-slate-500 dark:text-gray-500">No projects found.</p> : null}

          </div>

        </section>



        <section className={panelClass}>

          <div className="mb-3 flex items-center justify-between">

            <h2 className="text-sm font-bold text-slate-900 dark:text-white">Latest Blogs</h2>

            <Link to="/admin/modules/blogs" className="text-xs text-primary">View All</Link>

          </div>

          <div className="space-y-3">

            {blogs.slice(0, 3).map((item) => (

              <div key={item.id} className={innerCardClass}>

                <p className="font-bold text-slate-900 dark:text-white">{item.title}</p>

                <p className="text-xs text-slate-500 dark:text-gray-400">{item.summary?.slice(0, 60) || 'No summary'}...</p>

              </div>

            ))}

            {blogs.length === 0 ? <p className="text-sm text-slate-500 dark:text-gray-500">No blogs found.</p> : null}

          </div>

        </section>



        <section className={panelClass}>

          <h2 className="mb-3 text-sm font-bold text-slate-900 dark:text-white">Quick Actions</h2>

          <div className="grid grid-cols-2 gap-3">

            {[

              { to: '/admin/modules/service-overviews', label: 'Manage Service Cards' },

              { to: '/admin/modules/projects?portfolio=1', label: 'Manage Portfolio' },

              { to: '/admin/modules/blogs', label: 'Add Blog' },

              { to: '/admin/modules/messages', label: 'View Messages' },

              { to: '/admin/modules/profile-settings', label: 'Profile Settings' },

            ].map((action) => (

              <Link

                key={action.to}

                to={action.to}

                className={`${innerCardClass} text-center text-sm font-semibold text-slate-700 hover:border-primary dark:text-gray-100`}

              >

                {action.label}

              </Link>

            ))}

          </div>

        </section>

      </div>



      <p className="mt-6 text-xs text-slate-400 dark:text-gray-500">

        <FaChartBar className="inline-block mr-1" size={10} />

        2026 RAADSO TECH Admin Dashboard

      </p>

    </div>

  );

};



export default AdminDashboard;

